/**
 * Chaves do local storage
 */

// objeto com os dados do produto
export const DATA_PRODUCT = "produto";
// token de autenticacao
export const TOKEN_KEY = "login";
// objeto com os dados do usuario
export const DATA_USER = "usuario";
// token do carrinho
export const CART_TOKEN = "carrinho";
// token do editor
export const INFO_EDITOR = "editor";
// hash do editor
export const HASH_JOB = "hashEditor";
// operador simulando usuario
export const OPERATOR_SIM = "operador_simulando";
// usuario simulado
export const CLIENT_SIM = "cliente_simulado";
// refile
export const REFILE = "refile";
// cookie
export const COOKIE = "cookie";

// sessoes que precisam ser limpas ao realizar o logout
export const arrayClearLogout = [
  TOKEN_KEY,
  DATA_USER,
  CART_TOKEN,
  INFO_EDITOR,
  HASH_JOB,
  OPERATOR_SIM,
  CLIENT_SIM
];
